import { StyleSheet } from 'react-native';

import cardShadow from '../../Styles/cardShadow';

export default StyleSheet.create({
  containerStyle: theme => ({
    borderRadius: 6.2,
    paddingTop: 16,
    paddingBottom: 24,
    marginTop: 17,
    backgroundColor: theme.colors.cardBackgroundColor,
    ...cardShadow,
  }),
});
